import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/keyword/importer/keywordImporterActions';

export default importerReducers(actions);
